import React from "react";
import { PrimayDropdown } from "components/common/dropdown";
import { TableInput } from "components/common/input";
import { AskGraveMoveType } from "service/constant/serviceConstant";
import type { IAskGraveMoveDetail } from "service/interface/apply";

interface Props {
  data: IAskGraveMoveDetail;
  setData: React.Dispatch<React.SetStateAction<IAskGraveMoveDetail>>;
}

export function ApplyInfoTable({ data, setData }: Props) {
  const handleTypeClick = (id: number) => {
    setData((prev) => ({
      ...prev,
      type: id,
    }));
  };

  const handleMoveDateInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      moveDate: e.target.value,
    }));
  };

  const handleBurialCountInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      burialCount: e.target.value,
    }));
  };

  const handleBuriedPeriodInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({
      ...prev,
      buriedPeriod: e.target.value,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          신청 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            신청 서비스
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            <PrimayDropdown
              menuList={[
                ...Object.entries(AskGraveMoveType).map(([key, value]) => ({
                  id: Number(key),
                  name: value,
                })),
              ]}
              selectMenu={AskGraveMoveType[data.type]}
              onClick={handleTypeClick}
              label="신청 서비스"
            />
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            희망 이장 일자
          </div>
          <div className="flex h-full w-[303px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
            <TableInput value={data.moveDate} onChange={handleMoveDateInput} />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            봉분 기수
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.burialCount}
              onChange={handleBurialCountInput}
            />
          </div>
        </div>
        <div className="flex h-[86px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            묘소 안정 기간
          </div>
          <div className="flex h-full w-[787px] items-center px-[12px] text-M3 text-gray-5">
            <TableInput
              value={data.buriedPeriod}
              onChange={handleBuriedPeriodInput}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
